'use strict';

// activeModel: Caching app data that will be used throughout the app
angular.module('cvsApp').service('localyticsService',
		[function(){

			function localyticsService() {

			  this.eventlocalytics= function(EVENT, val){
				  try{
					 /*if(val != undefined && val != '')
					  {
						  console.log(JSON.stringify({EVENT:EVENT,
								ATTRIBUTES:val}));
					  } else {
						  console.log(JSON.stringify({EVENT:EVENT}));
					  }*/
					 if(val != undefined && val != '')
					  {
						  native.updateAnalytics(JSON.stringify({EVENT:EVENT,
								ATTRIBUTES:val}));
					  } else {
						  native.updateAnalytics(JSON.stringify({EVENT:EVENT}));
					  }
					  }catch(Execption){
				  		//console.log("Exception in activeModel -- "+Execption);
					}
				  
			  },
			  this.screenLocalytics= function(scrName){
				  try{
					  //console.log(JSON.stringify({scrName:scrName}));
					  native.updateAnalytics(JSON.stringify({scrName:scrName}));
					  }catch(Execption){
				  		//console.log("Exception in activeModel -- "+Execption);
					}
			  },
			  this.conversionLocalytics= function(EVENT, status){
				  try{
					  //console.log(JSON.stringify({EVENT:EVENT,ATTRIBUTES:status}));
					  native.updateAnalytics(JSON.stringify({EVENT:EVENT,
			  			ATTRIBUTES:status}));
					  }catch(Execption){
				  		//console.log("Exception in activeModel -- "+Execption);
					}
			  },
			  this.errorLocalytics= function(EVENT, message){
				  try{
					  native.updateAnalytics(JSON.stringify({"EVENT": EVENT,
				  			ATTRIBUTES:[{	"Message:": message}]}));
					  }catch(Execption){
				  		//console.log("Exception in activeModel -- "+Execption);
					}
			  };

		}
			
		return new localyticsService();
}]);